import { put, call } from 'redux-saga/effects';
import { ApolloError } from '@apollo/client'; // If using Apollo Client
import { Types } from './actions';
import InstitutionalInformationRepository from '@/domain/repositories/InstitutionalInformationRepository';
import InstitutionalInformationDataRepository from '@/data/repositories/InstitutionalInformationDataRepository';

export default function* getInstitutionalInformation(action: any): any {
  try {
    const { campus, career, zona } = action;
    yield put({ type: Types.GET_INSTITUTIONAL_INFORMATION_REQUEST });

    const institutionalInformation: InstitutionalInformationRepository =
      new InstitutionalInformationDataRepository();

    const institutionalInformationResponse = yield call(
      institutionalInformation.getInstitutionalInformation,
      campus,
      career,
      zona
    );

    if (!institutionalInformationResponse) {
      yield put({
        type: Types.GET_INSTITUTIONAL_INFORMATION_FAILURE,
        error: true
      });
      return;
    }
    yield put({
      type: Types.GET_INSTITUTIONAL_INFORMATION_SUCCESS,
      data: institutionalInformationResponse.institutionalInformation
    });
  } catch (error) {
    let errorMessage = 'Failed to fetch institutional information';
    if (error instanceof ApolloError) {
      errorMessage = 'Network error while fetching institutional information';
    }
    yield put({
      type: Types.GET_INSTITUTIONAL_INFORMATION_FAILURE,
      error: errorMessage
    });
  }
}
